import { create } from 'zustand';
import type { WorkOrderViewModel } from '@api/enterprise/openapi/models/work-order-view-model';

type WorkOrdersState = {
  workOrders: WorkOrderViewModel[];
  totalCount: number;
  isLoading: boolean;
  error: Error | null;

  setWorkOrders: (workOrders: WorkOrderViewModel[], totalCount: number) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: Error | null) => void;
  clearWorkOrders: () => void;
};

export const useWorkOrdersStore = create<WorkOrdersState>(set => ({
  workOrders: [],
  totalCount: 0,
  isLoading: false,
  error: null,

  setWorkOrders: (workOrders, totalCount) =>
    set({
      workOrders,
      totalCount,
      error: null
    }),

  setLoading: isLoading => set({ isLoading }),

  setError: error => set({ error, isLoading: false }),

  clearWorkOrders: () =>
    set({
      workOrders: [],
      totalCount: 0,
      isLoading: false,
      error: null
    })
}));
